// This is the main entry point for webpack.
// It should include the main resources to be webpack-ed, specific to this application.

// Add Import/Require lines for additional modules, including KendoUI, etc...
// See doc/client.md for more details and examples!

const VueUI = require('./js/vue-ui')

module.exports = {
   // Modules to expose to the application pages
   VueUI
}
